import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ClientSubscriptionFreezeType } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'freeze-type',
  templateUrl: './freeze-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class FreezeTypeComponent {
  private readonly cd = inject(ChangeDetectorRef);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  type!: any;

  getFreezeType(value: any) {
    // Check if value is already a number
    if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
      return ClientSubscriptionFreezeType[value];
    }

    // Check if value can be parsed as a valid integer
    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue) && isFinite(parsedValue)) {
      return ClientSubscriptionFreezeType[parsedValue];
    }

    // If value is not a number, return it as is (might be a string enum key)
    return value;
  }
}
